import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
};

const checkIsExitsReqLeaveSlice = createSlice({
  name: "checkIsExitsReqLeave",
  initialState,
  reducers: {
    checkIsExitsReqLeaveStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    checkIsExitsReqLeaveSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    checkIsExitsReqLeaveFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  checkIsExitsReqLeaveStart,
  checkIsExitsReqLeaveSuccess,
  checkIsExitsReqLeaveFailed,
} = checkIsExitsReqLeaveSlice.actions;

export default checkIsExitsReqLeaveSlice.reducer;
